import { useState } from "react";

/**
 * @typedef {import("@tanstack/table-core").RowSelectionState} RowSelectionState
 * @typedef {import("@tanstack/table-core").VisibilityState} VisibilityState
 * @typedef {import("@tanstack/table-core").ColumnFilter} ColumnFilter
 * @typedef {import("@tanstack/table-core").ColumnFiltersState} ColumnFiltersState
 */

/** @type {RowSelectionState} */
const emptyRowSelection = {};
/** @type {VisibilityState} */
const emptyColumnVisibility = {};
/** @type {ColumnFiltersState} */
const emptyColumnFilters = [];

/**
 * @typedef {{rowSelection: RowSelectionState, setColumnFilters: (value: (((prevState: ColumnFilter[]) => ColumnFilter[]) | ColumnFilter[])) => void, columnVisibility: VisibilityState, columnFilters: ColumnFilter[], setRowSelection: (value: (((prevState: RowSelectionState) => RowSelectionState) | RowSelectionState)) => void, setColumnVisibility: (value: (((prevState: VisibilityState) => VisibilityState) | VisibilityState)) => void}} TableState
 *
 * @returns {TableState}
 */
export const useTableState = () => {
  const [columnVisibility, setColumnVisibility] = useState(
    emptyColumnVisibility
  );
  const [rowSelection, setRowSelection] = useState(emptyRowSelection);
  const [columnFilters, setColumnFilters] = useState(emptyColumnFilters);

  return {
    columnVisibility,
    setColumnVisibility,

    rowSelection,
    setRowSelection,

    columnFilters,
    setColumnFilters,
  };
};
